import { TipoMensajeURLPath } from 'src/enums/EscritosLegales'

export const LOGOUT = '/logout'
export const MESSAGE = (messageId = ':messageId'): string => `/mensajes/${messageId}`
export const MESSAGES = (filter: 'pendientes' | 'firmadas' | '' = ''): string => {
  if (!filter) return '/mensajes'
  return `/mensajes/${filter}`
}
export const ACUSE = (messageId = ':messageId'): string => `/acuse/${messageId}`
export const ACUSES = (filter: 'pendientes' | 'aceptados' | 'rechazados' | '' = ''): string => {
  if (!filter) return '/acuses'
  return `/acuses/${filter}`
}
export const TRASLADO = (messageId = ':messageId'): string => `/traslado/${messageId}`
export const TRASLADOS = '/traslados'

export const ESCRITOS = (
  filter: 'borradores' | 'sin-enviar' | 'enviados' | 'aceptados' | 'rechazados' | '' = ''
): string => {
  if (!filter) return '/todos-los-escritos'
  return `/todos-los-escritos/${filter}`
}

export const OPEN_ESCRITO = '/escrito/nuevo'

export const AVISOS_LEXNET = (): string => '/avisos'
export const ESCRITOS_LEXNET = (filter: TipoMensajeURLPath): string => {
  return `/escritos/${filter}`
}
export const NO_AUTH = '/no-auth'

export const COOKIE_POLICY = '/politica-de-cookies'
